const AutoImportSources = {
    DocECM: 1,
    DocOfficeWord: 5,
    DocOfficeOutlook: 6,
    DocOfficePowerPoint: 7,
    DocOfficeExcel: 8,
    FileSystem: 15,
    Email: 14,
    OneDrive: 13,
    DocOfficeOutlook365: 16,
    DocOfficeExcel365: 17,
    DocOfficeWord365: 18,
    DocOfficePowerPoint365: 19,
    EmailOffice365: 20,

    1: 'DocECM',
    5: 'DocOfficeWord',
    6: 'DocOfficeOutlook',
    7: 'DocOfficePowerPoint',
    8: 'DocOfficeExcel',
    15: 'FileSystem',
    14: 'Email',
    13: 'OneDrive',
    16: 'DocOfficeOutlook365',
    17: 'DocOfficeExcel365',
    18: 'DocOfficeWord365',
    19: 'DocOfficePowerPoint365',
    20: 'EmailOffice365'
};

export default AutoImportSources;
